import type {
  CompanyLink,
  CompanySec,
  // Exchange,
  Defi,
  Learn,
  LearnSec,
  Products,
  Section,
} from './types'

export const products_tr: Products[] = [
  {
    tTitle: 'products.buyAndSell',
    tDesc: 'products.appDescription',
    href: '/app',
  },
  // {
  //   tTitle: "products.metalCards",
  //   tDesc: "products.metalCardsDescription",
  //   href: "/cards",
  // },
  {
    tTitle: 'products.earn',
    tDesc: 'products.earnDescription',
    href: '/earn',
  },
]

// export const exchange_tr: Exchange[] = [
//   {
//     tTitle: "products.exchangeIndex",
//     tDesc: "products.exchangeIndexDescription",
//     href: "https://crypto.com/exchange",
//   },
//   {
//     tTitle: "products.marginTrading",
//     tDesc: "products.marginTradingDescription",
//     href: "https://crypto.com/exchange/trade/margin/BTC_USDT",
//   },
//   {
//     tTitle: "products.derivatives",
//     tDesc: "products.derivativesDescription",
//     href: "https://crypto.com/exchange/perpetual",
//   },
// ]
export const defi_tr: Defi[] = [
  {
    tTitle: 'products.defiWallet',
    tDesc: 'products.defiWalletDescription',
    href: '/tr/defi-wallet',
  },
  {
    tTitle: 'products.browserExt',
    tDesc: 'products.browserExtDescription',
    href: '/tr/defi-wallet#wallet_extension',
  },
  {
    tTitle: 'products.desktopWallet',
    tDesc: 'products.desktopWalletDescription',
    href: '/tr/defi-wallet#defi_wallet_desktop',
  },
]

export const products_desktop_tr: Section[] = [
  {
    tTitle: 'products.sectionTitle_getStarted',
    items: [
      {
        tTitle: 'products.categoryTitle_buyAndSell',
        items: [
          {
            tTitle: 'products.app',
            tDesc: 'products.appDescription',
            href: '/tr/app',
          },
          {
            tTitle: 'products.nft',
            tDesc: 'products.nftDescription',
            href: 'https://crypto.com/nft',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_grow',
        items: [
          {
            tTitle: 'products.earn',
            tDesc: 'products.earnDescription',
            href: '/tr/earn',
          },
        ],
      },
    ],
  },
  {
    tTitle: 'products.sectionTitle_advancedTrading',
    items: [
      {
        tTitle: 'products.categoryTitle_defi',
        items: [
          {
            tTitle: 'products.defiWallet',
            tDesc: 'products.defiWalletDescription',
            href: '/tr/defi-wallet',
          },
          {
            tTitle: 'products.browserExt',
            tDesc: 'products.browserExtDescription',
            href: '/tr/defi-wallet#wallet_extension',
          },
          {
            tTitle: 'products.desktopWallet',
            tDesc: 'products.desktopWalletDescription',
            href: '/tr/defi-wallet#defi_wallet_desktop',
          },
        ],
      },
    ],
  },
]

export const learn_tr: Learn[] = [
  {
    tTitle: 'learn.trending',
    tDesc: 'learn.trendingDescription',
    href: '/trending',
  },
  {
    tTitle: 'learn.marketUpdates',
    tDesc: 'learn.marketUpdatesDescription',
    href: '/market-updates',
  },
  {
    tTitle: 'learn.productNews',
    tDesc: 'learn.productNewsDescription',
    href: '/product-news',
  },
  {
    tTitle: 'learn.events',
    tDesc: 'learn.eventsDescription',
    href: '/events',
  },
  {
    tTitle: 'learn.university',
    tDesc: 'learn.universityDescription',
    href: '/university',
  },
  {
    tTitle: 'learn.reportsAndAnalysis',
    tDesc: 'learn.reportsAndAnalysisDescription',
    href: '/research',
  },
  {
    tTitle: 'learn.nftStories',
    tDesc: 'learn.nftStoriesDescription',
    href: '/nft-stories',
  },
]

export const company_tr: CompanyLink[] = [
  {
    tTitle: 'company.about',
    tDesc: 'company.aboutDescription',
    href: '/tr/about',
  },
  {
    tTitle: 'company.careers',
    tDesc: 'company.careersDescription',
    href: '/tr/careers',
  },
  {
    tTitle: 'company.news',
    tDesc: 'company.newsDescription',
    href: 'https://crypto.com/company-news',
  },
  {
    tTitle: 'company.support',
    tDesc: 'company.supportDescription',
    href: 'https://help.crypto.com/en',
  },
  {
    tTitle: 'company.security',
    tDesc: 'company.securityDescription',
    href: '/tr/security',
  },
  {
    tTitle: 'company.partners',
    tDesc: 'company.partnersDescription',
    href: '/tr/partners',
  },
]

export const learn_desktop_tr: LearnSec[] = [
  {
    tTitle: 'learn.categoryTitle_updates',
    items: [
      {
        tTitle: 'learn.trending',
        tDesc: 'learn.trendingDescription',
        href: '/trending',
      },
      {
        tTitle: 'learn.events',
        tDesc: 'learn.eventsDescription',
        href: '/events',
      },
      {
        tTitle: 'learn.productNews',
        tDesc: 'learn.productNewsDescription',
        href: '/product-news',
      },
      {
        tTitle: 'learn.marketUpdates',
        tDesc: 'learn.marketUpdatesDescription',
        href: '/market-updates',
      },
    ],
  },
  {
    tTitle: 'learn.categoryTitle_resources',
    items: [
      {
        tTitle: 'learn.university',
        tDesc: 'learn.universityDescription',
        href: '/university',
      },
      {
        tTitle: 'learn.reportsAndAnalysis',
        tDesc: 'learn.reportsAndAnalysisDescription',
        href: '/research',
      },
      {
        tTitle: 'learn.nftStories',
        tDesc: 'learn.nftStoriesDescription',
        href: '/nft-stories',
      },
    ],
  },
]

export const company_desktop_tr: CompanySec[] = [
  {
    tTitle: 'company.sectionTitle_aboutUs',
    items: [
      {
        tTitle: 'company.about',
        tDesc: 'company.aboutDescription',
        href: '/tr/about',
      },
      {
        tTitle: 'company.support',
        tDesc: 'company.supportDescription',
        href: 'https://help.crypto.com/en',
      },
      {
        tTitle: 'company.careers',
        tDesc: 'company.careersDescription',
        href: '/tr/careers',
      },
      {
        tTitle: 'company.security',
        tDesc: 'company.securityDescription',
        href: '/tr/security',
      },
      {
        tTitle: 'company.news',
        tDesc: 'company.newsDescription',
        href: 'https://crypto.com/company-news',
      },
      {
        tTitle: 'company.partners',
        tDesc: 'company.partnersDescription',
        href: '/tr/partners',
      },
    ],
  },
]
